import React from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

import {toggleOverlay} from "../../screens/user/actions/userAction";


export class InfoOverlay extends React.Component {

  static propTypes = {
    overlayText: PropTypes.string,
    overlayLinkRef: PropTypes.string.isRequired,
    overlayLinkText: PropTypes.string.isRequired,
    overlayButtonText: PropTypes.string.isRequired,
    overlayBackground: PropTypes.string
  };

  onToggleOverlay = () => {
    this.props.dispatch(toggleOverlay(false))
  };

  render(){
    return <div className="overlayWrapper">
      <div className="overlayBodyContainer"
           style={{background: this.props.overlayBackground}}>
        <button className="buttonClose"
                onClick={this.onToggleOverlay}>
          <i className="fa fa-times"/>
        </button>
        <div className="overlayMessageContainer">
          <div className="overlayMessage">
            {this.props.overlayText}
          </div>
          <a className="buttonStyleLess" href={this.props.overlayLinkRef}>
            <i className="fa fa-plus"/>{this.props.overlayLinkText}
          </a>
          <button className="buttonStyleLess"
                  onClick={this.onToggleOverlay}>
            <i className="fa fa-check"/>{this.props.overlayButtonText}
          </button>
        </div>
      </div>
    </div>;
  }
}

export default withRouter(connect()(InfoOverlay));
